<div class="is-relative">
    <form [formGroup]="form" class="content-type-form" isavFieldIndex>
        <isav-field-index></isav-field-index>

        <isav-text-input
            label="1. Infrastructure name"
            formControlName="name"
            [mandatory]="true"
            tooltipKey="Infrastructure:name"
        ></isav-text-input>

        <isav-text-input
            label="2. Contact name"
            formControlName="contactName"
            [mandatory]="true"
            tooltipKey="Infrastructure:contactName"
        ></isav-text-input>

        <isav-text-input
            label="3. Contact phone"
            formControlName="contactPhone"
            tooltipKey="Infrastructure:contactPhone"
        ></isav-text-input>

        <isav-text-input
            label="4. Contact email"
            formControlName="contactEmail"
            [mandatory]="true"
            tooltipKey="Infrastructure:contactEmail"
        ></isav-text-input>

        <isav-taxonomy-select-input
            label="5. Organisation"
            placeholder="Select organisation"
            formControlName="organisation"
            taxonomy="Organisation"
            [mandatory]="true"
            tooltipKey="Infrastructure:organisation"
        ></isav-taxonomy-select-input>

        <isav-link-input
            label="6. Organisation link"
            formControlName="organizationLink"
            tooltipKey="Infrastructure:organizationLink"
        ></isav-link-input>

        <isav-link-input
            label="7. External link"
            formControlName="externalLink"
            tooltipKey="Infrastructure:externalLink"
        ></isav-link-input>

        <isav-taxonomy-select-input
            id="types"
            label="8. Types"
            placeholder="Select type"
            formControlName="types"
            taxonomy="Type"
            multiple
            [mandatory]="true"
            tooltipKey="Infrastructure:types"
        ></isav-taxonomy-select-input>

        <div *ngIf="isExportedFromSios" class="field is-horizontal">
            <div class="field-label field-label-tooltip"></div>
            <div class="field-body mt-1">
                <label class="checkbox">
                    <input
                        formControlName="dontOverrideTypesWhenExporting"
                        type="checkbox"
                        aria-label=""
                    />
                    Don’t override type from export
                </label>
            </div>
        </div>

        <isav-text-input
            label="9. Address"
            formControlName="address"
            tooltipKey="Infrastructure:address"
        ></isav-text-input>

        <isav-text-input
            label="10. Area code"
            formControlName="areaCode"
            tooltipKey="Infrastructure:areaCode"
        ></isav-text-input>

        <isav-text-input
            label="11. City"
            formControlName="city"
            tooltipKey="Infrastructure:city"
        ></isav-text-input>

        <isav-taxonomy-select-input
            label="12. Country"
            placeholder="Select country"
            formControlName="country"
            taxonomy="Country"
            [mandatory]="true"
            tooltipKey="Infrastructure:country"
        ></isav-taxonomy-select-input>

        <isav-taxonomy-select-input
            label="13. Region"
            placeholder="Select region"
            formControlName="region"
            taxonomy="Region"
            [mandatory]="true"
            tooltipKey="Infrastructure:region"
        ></isav-taxonomy-select-input>

        <isav-coordinates-input
            label="14. Location"
            formControlName="coordinates"
            [mandatory]="true"
            tooltipKey="Infrastructure:coordinates"
        ></isav-coordinates-input>

        <isav-content-editor
            label="15. Description"
            formControlName="description"
            [mandatory]="true"
            tooltipKey="Infrastructure:description"
            property="description"
            [iri]="value['@id']"
        ></isav-content-editor>

        <isav-image-form
            label="16. Image"
            formControlName="image"
            tooltipKey="Infrastructure:image"
            property="image"
            [contentIri]="value['@id']"
        ></isav-image-form>

        <isav-document-input
            label="17. Attachments"
            formControlName="attachments"
            tooltipKey="Infrastructure:attachments"
            [multiple]="true"
        ></isav-document-input>

        <isav-edit-sar
            [sar]="form.value.sarAsset"
            label="18. SAR asset"
            tooltipKey="Infrastructure:sarAsset"
        ></isav-edit-sar>

        <div class="is-flex is-space-between">
            <isav-go-to-view>Back to view</isav-go-to-view>
            <div class="buttons is-right">
                <ng-content></ng-content>
                <button type="button" isavBtn color="danger" class="ml-2" (click)="onDelete()">
                    Delete
                </button>
                <button
                    *ngIf="value.draft"
                    isavBtn
                    color="primary"
                    type="button"
                    [disabled]="!form.valid"
                    (click)="onPublish()"
                >
                    Publish
                </button>
                <button
                    *ngIf="!value.draft"
                    isavBtn
                    color="danger"
                    type="button"
                    (click)="onUnpublish()"
                >
                    Unpublish
                </button>
                <button
                    type="button"
                    isavBtn
                    color="success"
                    [disabled]="!value.draft && !form.valid"
                    (click)="onSave()"
                >
                    Save
                </button>
            </div>
        </div>
    </form>
</div>
